import React from 'react';

import {Box, Button, Code, Flex, Heading, Image, Text} from '@spothero/ui';

import {
    devErrorImageProps,
    stackTraceContainerStyleProps,
    errorCodeStyleProps,
} from '../error-display-style.props';
import errorBoundaryProps from '../error-boundary.props';

const DevMode = ({error, componentStack, resetError}) => {
    const {name, message} = error.cause;
    const componentStackLineArray = componentStack
        .split('\n')
        .filter((line) => line !== '');

    return (
        <>
            <Image {...devErrorImageProps} />
            <Flex direction="column" justifyContent="space-around" height={28}>
                <Button onClick={resetError}>Reset Error</Button>
                <Heading as="h3">Dev Error Display</Heading>
            </Flex>
            <Flex
                data-testid="DevMode-ErrorContent"
                {...stackTraceContainerStyleProps}
            >
                <Box>
                    <Text fontSize="lg" {...errorCodeStyleProps}>
                        {name}
                    </Text>
                    <Text fontSize="base" {...errorCodeStyleProps}>
                        {message}
                    </Text>
                </Box>
                <Box>
                    <Text>Call Stack</Text>
                    {componentStackLineArray.map((line, index) => (
                        <Code
                            key={index}
                            children={line}
                            fontSize="sm"
                            {...errorCodeStyleProps}
                        />
                    ))}
                </Box>
            </Flex>
        </>
    );
};

DevMode.propTypes = errorBoundaryProps;

export default DevMode;
